import React from 'react';
import { Box, Typography } from '@trp-individual-investor-adv-svc/ii-prosp-components';

import { PsBeaconControl, PsBeaconControlGroup } from '../../shared/BeaconRegister';
import { acctSelHeader, InvestmentInfoContent } from '../../ConsentComponents/ConsentContent';
import YodleeConsentSection from '../../ConsentComponents/YodleeConsentSection';

const AccountSelectionContent = ({ showYodleeConsent, includeInvestmentContent, handleChange }) => {
    return (
        <Box
            id="acct-selection-container"
            className="beacon-theme-modern-outlook beacon-on-light"
            sx={{ maxWidth: '1600px' }}>
            {includeInvestmentContent && (
                <Box
                    id="acct-selection-full-content-container"
                    sx={{
                        marginBottom: '34px',
                    }}>
                    <Box id="acct-selection-title-content-container">
                        <Typography
                            id="acct-selection-title"
                            type="headline" serif scale={400}
                            sx={{ paddingBottom: '16px' }}>
                            {acctSelHeader}
                        </Typography>
                        <Box id="acct-selection-content-container">
                            <Typography
                                id="acct-selection-content-1"
                                type="body" scale={100}
                                sx={{ paddingBottom: '36px' }}>
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: InvestmentInfoContent.header,
                                    }}
                                />
                            </Typography>
                            <Typography
                                id="acct-selection-content-2"
                                type="body" scale={100}
                                sx={{ paddingBottom: '36px' }}>
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: InvestmentInfoContent.explanation,
                                    }}
                                />
                            </Typography>
                            <Typography
                                id="acct-selection-content-3"
                                type="body" scale={100}>
                                {InvestmentInfoContent.note}
                            </Typography>
                        </Box>
                    </Box>
                </Box>
            )}
            <Box sx={{ paddingBottom: '40px' }}>
                <Box id="authorization-explanation-container">
                    <Typography
                        dangerouslySetInnerHTML={{
                            __html: InvestmentInfoContent.mutualFundSection[0].contentHeader,
                        }}
                        bold
                        id="investment-info-header-3"
                        sx={{ paddingBottom: '16px' }}
                    />

                    <Typography
                        type="body" scale={100} light
                        id={InvestmentInfoContent.mutualFundSection[0].id}>
                        <span
                            dangerouslySetInnerHTML={{
                                __html: InvestmentInfoContent.mutualFundSection[0].content,
                            }}
                        />
                    </Typography>
                </Box>
            </Box>

            <Box id="workplace-retirement-section-container" sx={{ paddingBottom: '40px' }}>
                <Box id="workplace-retirement-container">
                    <Typography
                        id="workplace-retirement-header"
                        type="headline" scale={50} bold
                        sx={{ paddingBottom: '16px' }}>
                        <span
                            dangerouslySetInnerHTML={{
                                __html: InvestmentInfoContent.workplaceTrustSection.header,
                            }}
                        />
                    </Typography>
                    <Typography
                        id="workplace-retirement-disclosure"
                        type="body" scale={100} light
                        sx={{ paddingBottom: '36px' }}>
                        <span
                            dangerouslySetInnerHTML={{
                                __html: InvestmentInfoContent.workplaceTrustSection.content,
                            }}
                        />
                    </Typography>
                    <Typography
                        id="workplace-retirement-disclosure-long-note"
                        type="body" scale={100} light
                        sx={{ paddingBottom: '36px' }}>
                        {InvestmentInfoContent.longNote}
                    </Typography>
                    <Box id="accounts-checkboxes-form-container">
                        <Box
                            id="accounts-checkboxes-container"
                            sx={{
                                border: '1px solid #A8AFB5',
                                padding: '24px',
                                marginBottom: '40px',
                            }}
                            className="b-flow-space">
                            <Typography
                                id="workplace-retirement-auth-message"
                                type="body" scale={100} light
                                sx={{ paddingBottom: '24px' }}>
                                <span
                                    dangerouslySetInnerHTML={{
                                        __html: InvestmentInfoContent.authorize,
                                    }}
                                />
                            </Typography>
                            <PsBeaconControlGroup>
                                <PsBeaconControl inline>
                                    <label
                                        slot="label"
                                        id="agreement401k-label"
                                        htmlFor="agreement401k">
                                        Workplace Retirement Account(s)
                                    </label>
                                    <input
                                        type="checkbox"
                                        name="agreement401k"
                                        id="agreement401k"
                                        onChange={handleChange('checked401k')}
                                    />
                                </PsBeaconControl>
                                <PsBeaconControl inline style={{ paddingBottom: '24px' }}>
                                    <input
                                        type="checkbox"
                                        name="checkedTrust"
                                        id="checkedTrust"
                                        onChange={handleChange('checkedTrust')}
                                    />
                                    <label
                                        slot="label"
                                        id="checkedTrust-label"
                                        htmlFor="checkedTrust">
                                        Trust Account(s)
                                    </label>
                                </PsBeaconControl>
                            </PsBeaconControlGroup>
                            <PsBeaconControlGroup style={{ marginTop: '0px' }}>
                                <PsBeaconControl inline id="review-checkbox-control">
                                    <input
                                        type="checkbox"
                                        required
                                        name="checkedConfirmation"
                                        id="checkedConfirmation"
                                        onChange={handleChange('checkedConfirmation')}
                                    />
                                    <label
                                        className="b-font-weight-bold"
                                        slot="label"
                                        id="checkedConfirmation-label"
                                        htmlFor="checkedConfirmation">
                                        {InvestmentInfoContent.checkboxLabel}
                                    </label>
                                    <div slot="error">This field is required.</div>
                                </PsBeaconControl>
                            </PsBeaconControlGroup>
                        </Box>
                    </Box>
                </Box>
            </Box>
            {showYodleeConsent && (
                <Box id="aggregation-service-section-container" sx={{ paddingBottom: '40px' }}>
                    <Box id="aggregation-service-background-container">
                        <YodleeConsentSection handleChange={handleChange} idSuffix="acct-sel" />
                    </Box>
                </Box>
            )}
            <Typography
                id="authorization-explanation-2"
                type="body" scale={100} light>
                {InvestmentInfoContent.closingSection}
            </Typography>
        </Box>
    );
};

export default AccountSelectionContent;
